import { gameHasEnded, gameHasStarted, submissionsAreClosed } from '@pkg/hooks';

import { type Competition } from '@app/client';

export function getFormattedGameData(currentGame?: Competition) {
    const currentCompetitionMax = Number(currentGame?.max_assets || 0);
    const gameStarted = gameHasStarted(currentGame?.submission_starts_at);
    const gameEnded = gameHasEnded(currentGame?.ends_at);
    const submissionsClosed = submissionsAreClosed(currentGame?.submission_ends_at);
    const currentGameWishlistData = currentGame?.wishlists;
    const currentGameWishlist = currentGameWishlistData?.[0];
    return {
        currentGame,
        gameEnded,
        gameStarted,
        submissionsClosed,
        currentGameWishlistData,
        currentGameWishlist,
        currentGameWishlistId: currentGameWishlist?.id,
        currentCompetitionMax,
    };
}
